import React, { Fragment } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { NavLink, Switch } from "react-router-dom";
import "./Nav.css";
import ProtectedRoute from "../../auth/protected-route";
import AuthenticationButton from "../AuthenticationButton/AuthenticationButton";
import PermissionWrapper from '../../auth/PermissionWrapper';
import Home from '../../pages/Home';
import BackOfficeAnalytics from '../../pages/BackOfficeAnalytics';
import BOTRequests from '../../pages/BOTRequests';
import BOTManagement from '../../pages/BOTManagement';
import Client from '../../pages/Client';
import Companies from '../../pages/Companies';
import Employees from '../../pages/Employees';
import Import from '../../pages/Import';
import Reports from '../../pages/Reports';
import RevenueManagement from '../../pages/RevenueManagement';
import Services from '../../pages/Services';
import TimeTracking from '../../pages/TimeTracking';
import Training from '../../pages/Training';
import Users from '../../pages/Users';
import Widgets from '../../pages/Widgets';
import Workflows from '../../pages/Workflows';
import Help from '../../pages/Help';

class Nav extends React.Component {
    constructor(props) {
        super(props);

        this.links = [
            { url: "/", link: "Home", authenticated: true, align: 'left', cb: () => this.props.refreshUser() },
            { url: "/reports", link: "Reports", permission: "Reports", authenticated: true, align: 'left' },
            { url: "/import", link: "Import", permission: "Import", authenticated: true, align: 'left' },
            { url: "/workflows", link: "Workflows", permission: "Workflows", authenticated: true, align: 'left' },
            { url: "/services", link: "Services", permission: "Services", authenticated: true, align: 'left' },
            { url: "/employees", link: "Employees", permission: "Employees", authenticated: true, align: 'left' },
            { url: "/time-tracking", link: "Time Tracking", permission: "Time Tracking", authenticated: true, align: 'left' },
            { url: "/training", link: "Training", permission: "Training", authenticated: true, align: 'left' },
            { url: "/back-office-analytics", link: "BO Analytics", permission: "Back Office Analytics", authenticated: true, align: 'left' },
            { url: "/bot-requests", link: "BOT Requests", permission: "View BOT Requests", authenticated: true, align: 'left' },
            { url: "/bot-management", link: "BOT Mgmt", permission: "View BOT Mgmt", authenticated: true, align: 'left' },
            { url: "/revenue-management", link: "Revenue Mgmt", permission: "Revenue Management", authenticated: true, align: 'left' },
            { url: "/users", link: "User Admin", permission: "Admin Access", authenticated: true, align: 'left' },
            { url: "/companies", link: "Company Admin", permission: "Clients", authenticated: true, align: 'left' },
            { url: "/widgets", link: "Widgets", permission: "Widgets", authenticated: true, align: 'left' },
            { url: "/help", link: "Help", permission: "Help", authenticated: true, align: 'left' },
        ]
    }

    componentDidMount = () => {
        this.props.log('Nav.js/componentDidMount');
    }

    checkPermission = (permission) => {
        this.props.info('Nav.js/checkPermission (permission)', permission);
        const permissionGranted =
            permission === '' || permission == null ||
            this.props.userPermissions.findIndex(i => i.toUpperCase() === permission.toUpperCase()) > -1;
        return permissionGranted;
    }

    render() {
        this.props.info('Nav.js/render');
        return (
            <>
                <nav className="Nav">
                    <Container fluid>
                        <Row>
                            <Col md={10} className="text-left">
                                {this.links.map(link => {
                                    if ((link.authenticated && this.props.isAuthenticated) || link.authenticated == null) {
                                        if ((link.permission != null && this.checkPermission(link.permission)) || link.permission == null) {
                                            return (
                                                <NavLink key={link.url} exact
                                                    activeClassName="navbar__link--active"
                                                    className="navbar__link"
                                                    onClick={()=> { if (link.cb != null) link.cb();}}
                                                    to={link.url}>{link.link}</NavLink>
                                            )
                                        } else {
                                            return (<Fragment key={link.url}></Fragment>);
                                        }
                                    } else {
                                        return (<Fragment key={link.url}></Fragment>);
                                    }
                                })}
                            </Col>
                            <Col md={2} className="text-right align-items-end justify-content-end d-flex">
                                <AuthenticationButton />
                            </Col>
                        </Row>
                    </Container>
                </nav>
                <Switch>
                    <ProtectedRoute exact component={(props) => <Home {...props} {...this.props} {...this.state} />} path="/" />
                    <ProtectedRoute exact path="/back-office-analytics" component={(props) =>
                        <PermissionWrapper refreshUser={this.props.refreshUser} {...props} {...this.props} {...this.state} allowedPermission="Back Office Analytics">
                            <BackOfficeAnalytics {...props} {...this.props} {...this.state} />
                        </PermissionWrapper>} />
                    <ProtectedRoute exact path="/bot-requests" component={(props) =>
                        <PermissionWrapper refreshUser={this.props.refreshUser} {...props} {...this.props} {...this.state} allowedPermission="View BOT Requests">
                            <BOTRequests {...props} {...this.props} {...this.state} />
                        </PermissionWrapper>} />
                    <ProtectedRoute path="/bot-management" component={(props) =>
                        <PermissionWrapper refreshUser={this.props.refreshUser} {...props} {...this.props} {...this.state} allowedPermission="View BOT Mgmt">
                            <BOTManagement {...props} {...this.props} {...this.state} />
                        </PermissionWrapper>} />
                    <ProtectedRoute exact path="/companies" component={(props) =>
                        <PermissionWrapper refreshUser={this.props.refreshUser} {...props} {...this.props} {...this.state} allowedPermission="Admin Access">
                            <Companies {...props} {...this.props} {...this.state} />
                        </PermissionWrapper>} />
                    <ProtectedRoute path="/company" component={(props) =>
                        <PermissionWrapper refreshUser={this.props.refreshUser} {...props} {...this.props} {...this.state} allowedPermission="Clients">
                            <Client {...props} {...this.props} {...this.state} />
                        </PermissionWrapper>} />
                    <ProtectedRoute exact path="/employees" component={(props) =>
                        <PermissionWrapper refreshUser={this.props.refreshUser} {...props} {...this.props} {...this.state} allowedPermission="Employees">
                            <Employees {...props} {...this.props} {...this.state} />
                        </PermissionWrapper>} />
                    <ProtectedRoute exact path="/import" component={(props) =>
                        <PermissionWrapper refreshUser={this.props.refreshUser} {...props} {...this.props} {...this.state} allowedPermission="Import">
                            <Import {...props} {...this.props} {...this.state} />
                        </PermissionWrapper>} />
                    <ProtectedRoute path="/reports" component={(props) =>
                        <PermissionWrapper refreshUser={this.props.refreshUser} {...props} {...this.props} {...this.state} allowedPermission="Reports">
                            <Reports {...props} {...this.props} {...this.state} />
                        </PermissionWrapper>} />
                    <ProtectedRoute path="/revenue-management" component={(props) =>
                        <PermissionWrapper refreshUser={this.props.refreshUser} {...props} {...this.props} {...this.state} allowedPermission="Revenue Management">
                            <RevenueManagement {...props} {...this.props} {...this.state} />
                        </PermissionWrapper>} />
                    <ProtectedRoute exact path="/services" component={(props) =>
                        <PermissionWrapper refreshUser={this.props.refreshUser} {...props} {...this.props} {...this.state} allowedPermission="Services">
                            <Services {...props} {...this.props} {...this.state} />
                        </PermissionWrapper>} />
                    <ProtectedRoute exact path="/time-tracking" component={(props) =>
                        <PermissionWrapper refreshUser={this.props.refreshUser} {...props} {...this.props} {...this.state} allowedPermission="Time Tracking">
                            <TimeTracking {...props} {...this.props} {...this.state} />
                        </PermissionWrapper>} />
                    <ProtectedRoute exact path="/training" component={(props) =>
                        <PermissionWrapper refreshUser={this.props.refreshUser} {...props} {...this.props} {...this.state} allowedPermission="Training">
                            <Training {...props} {...this.props} {...this.state} />
                        </PermissionWrapper>} />
                    <ProtectedRoute exact path="/users" component={(props) =>
                        <PermissionWrapper refreshUser={this.props.refreshUser} {...props} {...this.props} {...this.state} allowedPermission="Admin Access">
                            <Users {...props} {...this.props} {...this.state} />
                        </PermissionWrapper>} />
                    <ProtectedRoute path="/widgets" component={(props) =>
                        <PermissionWrapper refreshUser={this.props.refreshUser} {...props} {...this.props} {...this.state}>
                            <Widgets {...props} {...this.props} {...this.state} />
                        </PermissionWrapper>} />
                    <ProtectedRoute exact path="/workflows" component={(props) =>
                        <PermissionWrapper refreshUser={this.props.refreshUser} {...props} {...this.props} {...this.state} allowedPermission="Workflows">
                            <Workflows {...props} {...this.props} {...this.state} />
                        </PermissionWrapper>} />
                    <ProtectedRoute exact path="/help" component={(props) =>
                        <PermissionWrapper refreshUser={this.props.refreshUser} {...props} {...this.props} {...this.state} allowedPermission="Help">
                            <Help {...props} {...this.props} {...this.state} />
                        </PermissionWrapper>} />
                </Switch>
            </>
        );
    }
}

export default Nav;